module.exports = __webpack_public_path__ + "static/media/SVGQuotes.1e1f693e.svg";